import React from 'react'
import { Stack, Typography, useTheme } from '@mui/material'

export const SeedStatsLabel = ({ title, value }: { title: string; value: string }) => {
  const theme = useTheme()
  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Typography variant='body2' color={theme.colors.primary500} fontWeight='700'>
        {title}
      </Typography>
      <Typography variant='body2' color={theme.colors.primary500}>
        {value}
      </Typography>
    </Stack>
  )
}
